<template>
    <article class="article-content">
        <slot name="share-bar"></slot>

        <div class="article-content__content">
            <category-pill :name="category" :url="categoryUrl" :color="color" />
            <p class="article-content__date">
                Publié le {{ date }}
            </p>
            <h2 class="article-content__title" v-html="title"></h2>

            <slot name="cms-content"></slot>
        </div>
    </article>
</template>

<script>
    import CategoryPill from '@/components/CategoryPill';

    export default {
        name: 'ArticleContent',

        components: { CategoryPill },

        props: {
            title:       { type: String, required: true },
            date:        { type: String, required: true },
            category:    { type: String, required: true },
            categoryUrl: { type: String, required: true },
            color:       { type: String, required: true },
        },
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .article-content {
        display:         flex;
        flex-direction:  column;
        align-items:     flex-start;
        justify-content: flex-start;

        &__content {
            padding-top: 3rem;
            max-width:   100%;

            @include media-breakpoint-up(sm) {
                padding-top: 6rem;
            }
        }

        &__category {
            display:       inline-block;
            height:        1.9rem;
            padding:       0 2rem;
            border-radius: 1rem;

            @extend %font-OpenSans-bold;
            font-size:     1.2rem;
            line-height:   1.9rem;
            color:         white;

        }

        &__date {
            margin-top:    1rem;
            margin-bottom: 0;

            @include media-breakpoint-up(sm) {
                margin-top: 1.5rem;
            }
        }

        &__title {
            margin-top:  0.5rem;

            @extend %font-OpenSans-light;
            font-size:   3rem;
            line-height: 3.5rem;

            @include media-breakpoint-up(sm) {
                margin-top:  1rem;
                font-size:   5rem;
                line-height: 5.4rem;
            }
        }

        &__share-bar {
            order:       2;
            border-top:  0.1rem solid $gray-200;
            padding-top: 2rem;
            width:       100%;
            margin-top:  4.5rem;

            @include media-breakpoint-up(sm) {
                align-self:  flex-end;
                order:       0;
                border-top:  none;
                padding-top: 0;
                width:       auto;
            }
        }

        &__cms-content {
            margin-top: 2.5rem;

            @include media-breakpoint-up(sm) {
                margin-top: 5rem;
            }
        }
    }
</style>
